export default __webpack_public_path__ + "static/media/ellipsis.985a94c5.svg";